import React from 'react'
import { useEffect } from 'react'
export default function Badpage() {

    useEffect(() => {
           
            localStorage.clear();
        window.open(process.env.REACT_APP_CLOSING_URL, "_self"); 
   
    }, [])
  return (
    <div></div>
  )
}
